import Image from 'next/image';

import { Box, Flex, Heading, Link, Tag, TagLabel, Text } from '@chakra-ui/react';

import {
  AI_MARKETER_ANALYTICS_EVENT,
  COMING_SOON_PROGRAM,
  COPY,
  STAY_UP_TO_DATE_SECTION_ID,
} from '~/features/ai-marketer/constants';
import { MegaphoneIcon } from '~/features/ai-marketer/icons';
import { focusStayPostedEmailAfterScroll } from '~/features/ai-marketer/utils/focus-stay-posted-email';
import { trackEvent } from '~/features/analytics/track-event';

export function ComingSoonCard() {
  return (
    <Box
      as='article'
      bg='grey.100'
      border='1px solid'
      borderColor='grey.100'
      borderRadius={{ base: '8px', md: '12px' }}
      display='flex'
      flexDirection='column'
      height='100%'
      overflow='hidden'
      position='relative'
    >
      <Flex
        bg='white'
        borderRadius={{ base: '8px', md: '12px' }}
        boxShadow='0px 0px 32px 0px #0000001F'
        flex={1}
        flexDirection='column'
        gap={{ base: '10px', md: '16px' }}
        padding={{ base: '6px 6px 12px', md: '8px 8px 14px' }}
      >
        <Box
          bg='purple.500'
          borderRadius={{ base: '4px', md: '8px' }}
          flex={{ base: '0 0 78px', md: '0 0 120px' }}
          overflow='hidden'
          position='relative'
        >
          <Box inset={0} mixBlendMode='hard-light' position='absolute'>
            <Image
              alt=''
              sizes='(max-width: 48em) 50vw, 256px'
              src='/images/ai-marketer/coming-soon-card.webp'
              style={{ objectFit: 'cover', pointerEvents: 'none', filter: 'grayscale(100%)' }}
              fill
            />
          </Box>
          <Tag
            bg='purple.100'
            borderRadius='4px'
            boxShadow='none'
            padding='4px 8px'
            position='absolute'
            right='8px'
            top='8px'
            variant='no-stroke'
          >
            <TagLabel
              color='#3A006A'
              fontFamily='condensed'
              fontSize='0.875rem'
              fontWeight='500'
              letterSpacing='0.08em'
              lineHeight='1'
              textTransform='uppercase'
            >
              {COPY.startLearning.comingSoonLabel}
            </TagLabel>
          </Tag>
          <Box
            bottom='8px'
            height={{ base: '28px', md: '40px' }}
            left='8px'
            position='absolute'
            width={{ base: '28px', md: '40px' }}
          >
            <Image alt='' src='/images/school-icons/business.svg' fill />
          </Box>
        </Box>
        <Flex flex={1} flexDirection='column' gap='12px' px={{ base: 2, md: 3 }}>
          <Heading
            as='h3'
            color='purple.500'
            fontFamily='body'
            fontSize={{ base: '0.75rem', md: '0.9375rem' }}
            fontWeight='600'
            lineHeight='1.4'
          >
            {COMING_SOON_PROGRAM.title}
          </Heading>
          <Text
            color='grey.500'
            fontSize={{ base: '0.625rem', md: '0.75rem' }}
            lineHeight='1.4'
            noOfLines={{ base: 3, md: 5 }}
          >
            {COMING_SOON_PROGRAM.summary}
          </Text>
        </Flex>
        <Box borderTop='1px solid #F2F2F2' mx={{ base: 2, md: 3 }} pt={{ base: '12px', md: '16px' }}>
          <Link
            _hover={{ color: 'white', textDecoration: 'none', opacity: 0.9 }}
            _visited={{ color: 'white' }}
            alignItems='center'
            bgGradient='linear(to-r, purple.700, blue.700)'
            borderRadius='4px'
            color='white'
            display='flex'
            fontSize='0.75rem'
            fontWeight='400'
            href={`#${STAY_UP_TO_DATE_SECTION_ID}`}
            justifyContent='center'
            lineHeight='1.4'
            px={{ base: '8px', md: '16px' }}
            py={{ base: '8px', md: '10px' }}
            textDecoration='none'
            _focusVisible={{
              outline: '2px solid',
              outlineColor: 'blue.500',
              outlineOffset: '2px',
            }}
            sx={{
              '&::before': {
                content: '""',
                inset: 0,
                position: 'absolute',
              },
            }}
            onClick={() => {
              trackEvent({
                type: 'click',
                name: AI_MARKETER_ANALYTICS_EVENT,
                label: 'coming_soon_clicked',
              });
              focusStayPostedEmailAfterScroll();
            }}
          >
            <MegaphoneIcon color='white' height='14px' mr='10px' width='14px' />
            {COPY.startLearning.notifyMe}
          </Link>
        </Box>
      </Flex>
    </Box>
  );
}
